Namespace 'Common.Dashboard.Filters'

class Common.Dashboard.Filters.AppliedFilterEditButtonView extends Backbone.View
  tagName: 'span'
  className: 'edit-button'

  events:
    'click': 'edit'

  render: ->
    @$el.text I18n.t('common.session.filters.multiple_values.edit')
    @

  edit: ->
    @trigger 'edit'
